import { ImageLoading } from "@/utilities/imageLoading";
import Image from "../image/image";
import css from "./checkmark-icon.module.scss";

enum CheckmarkIconStyle {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

interface ICheckmarkIconProps {
  className?: string;
  style?: CheckmarkIconStyle;
  loading?: ImageLoading;
}

const CheckmarkIcon = (props: ICheckmarkIconProps) => {
  const {
    className,
    style = CheckmarkIconStyle.PRIMARY,
    loading = ImageLoading.LAZY,
  } = props;

  return (
    <span className={`${css.checkmarkIcon} ${className} ${css[style]}`}>
      <Image
        className="image object-contain"
        src="/checkmark.svg"
        alt="checkmark icon"
        width={24}
        height={24}
        loading={loading}
      />
    </span>
  );
};

export default CheckmarkIcon;
